import Vue from 'vue'
import Router from 'vue-router'

// 登录
const login = () => import('../components/login')
import layout from '../components/layout'
import home from '../components/home'
import index from '../components/website/index'
import aboutUs from '../components/website/aboutUs/aboutUs'
import news from '../components/website/news/news'
import product from '../components/website/product/product'
import contact from '../components/website/contact/contact'
import notice from '../components/website/notice/notice'
import quality from '../components/website/quality/quality'
import stuffEnter from '../components/website/stuffEnter'
import coronavirus from '../components/website/coronavirus/coronavirus'
import menu from '../components/management/menuManagement'
import loginMenuManagement from '../components/management/loginMenuManagement'
import newsManagement from '../components/management/newsList'
// import productManagement from "../components/management/productList"
import employManagement from '../components/management/employList'
import noticeManagement from '../components/management/noticeList'

Vue.use(Router)

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/ms',
      name: 'layout',
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      },
      component: layout,
      children: [
        //菜单管理
        {
          path: '/ms/menu',
          name: 'menu',
          component: menu
        },
        //菜单权限管理
        {
          path: '/ms/loginMenuManagement',
          name: 'loginMenuManagement',
          component: loginMenuManagement
        },
        //新闻管理管理
        {
          path: '/ms/newsManagement',
          name: 'newsManagement',
          component: newsManagement
        },
        //产品与服务管理
        // {
        //   path: '/ms/productManagement',
        //   name: 'productManagement',
        //   component: productManagement,
        // },
        //招聘管理
        {
          path: '/ms/employManagement',
          name: 'employManagement',
          component: employManagement
        },
        //公告管理
        {
          path: '/ms/noticeManagement',
          name: 'noticeManagement',
          component: noticeManagement
        }
      ]
    },
    {
      path: '/',
      name: 'home',
      component: home,
      children: [
        //首页
        {
          path: '/',
          name: 'index',
          component: index
        },
        //关于华晟
        {
          path: '/aboutUs',
          name: 'aboutUs',
          component: aboutUs
        },
        //新闻动态
        {
          path: '/news',
          name: 'news',
          component: news
        },
        //新闻动态
        {
          path: '/product',
          name: 'product',
          component: product
        },
        //联系我们
        {
          path: '/contact',
          name: 'contact',
          component: contact
        },
        //公告栏
        {
          path: '/notice',
          name: 'notice',
          component: notice
        },
        //质量管理
        {
          path: '/quality',
          name: 'quality',
          component: quality
        },
        //员工入口
        {
          path: '/stuffEnter',
          name: 'stuffEnter',
          component: stuffEnter
        },
        //赴日心冠
        {
          path: '/coronavirus',
          name: 'coronavirus',
          component: coronavirus
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js